import { memo, useState } from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
//Local files
import { Actions, Content } from './Email.styled';
import BaseDialog from 'components/Common/Feedback/BaseDialog/BaseDialog';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import { checkValidEmail } from 'helpers';

const Email = ({ open, onClose, onChange }) => {
  const [step, /*setStep*/] = useState('send');
  const [email, setEmail] = useState({ value: '', error: '' });;

  const handleChange = () => {
    let hasError = false;

    if (!checkValidEmail(email.value)) {
      setEmail(prev => ({ ...prev, error: `Email is invalid` }) );
      hasError = true;
    }
    if (hasError) return;

    onChange(email.value);
    onClose();
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      otherPaperStyle={{ width: '100%', maxWidth: 360 }}
      title='Change current email'
      content={
        <Content>
          {step === 'send' && <>
            <Typography variant='caption' component='p' align='center' py={1}>ENTER NEW EMAIL</Typography>
            <TextField
              fullWidth
              margin='normal'
              label='Email'
              type='email'
              value={email.value}
              onChange={({ target: { value } }) => setEmail({ value, error: '' })}
              helperText={email.error}
              error={!!email.error}
            />
            <Actions>
              <Button variant='outlined' sx={{ minWidth: 110 }} onClick={onClose}>Cancel</Button>
              <Button variant='contained' color='primary' sx={{ minWidth: 110 }} onClick={handleChange}>Next</Button>
            </Actions>
          </>}
          {step === 'code' && <>
            <Typography variant='caption' component='p' align='center' py={1}>ENTER YOUR 5 DIGIT CODE</Typography>
            <TextField
              fullWidth
              margin='normal'
              label='Code'
              type='number'
            />
            <Typography variant='caption' component='p' align='center' color='textSecondary' py={1}>Your code was sent to {email.value}</Typography>
            <Actions>
              <Button variant='outlined' sx={{ minWidth: 110 }} onClick={onClose}>Cancel</Button>
              <Button variant='contained' color='primary' sx={{ minWidth: 110 }}>Save</Button>
            </Actions>
          </>}
        </Content>
      }
    />
  )
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Email {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);